import { z } from 'zod';
export const ListCategoriesQuery = z.object({
    /** Default `active`. `archived` returns soft-deleted; `all` is both. */
    filter: z.enum(['active', 'archived', 'all']).optional(),
    /** When set, return ONLY direct children of the given parent.
     *  `'root'` returns top-level categories (parentId IS NULL). */
    parentId: z.union([z.string().uuid(), z.literal('root')]).optional(),
});
//# sourceMappingURL=requests.js.map